export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12477.5a66c4c9.jpg";